exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svgShadow___svg-shadow___2UWmw {\n    filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.5));\n}", ""]);

// exports
exports.locals = {
	"svg-shadow": "svgShadow___svg-shadow___2UWmw",
	"svgShadow": "svgShadow___svg-shadow___2UWmw"
};